(function () {

  /**
   * @param {string} [returnTo]
   */
  function buildLoginUrl(returnTo) {
    const resideoIdSignInLink = document.querySelector('input[name="resideo_id_sign_in_link"]');
    if (!resideoIdSignInLink) {
      return '';
    }
    const url = new URL(resideoIdSignInLink.getAttribute('value'));
    url.searchParams.set('return_to', returnTo || window.location.pathname);
    return url.toString();
  }

  /**
   * Prefer an explicit relative path (e.g. /pages/order-history) when present.
   * @param {HTMLAnchorElement} link
   */
  function getReturnTo(link) {
    const fromData = link.getAttribute('data-return-to');
    if (fromData) {
      try {
        return new URL(fromData, window.location.origin).pathname;
      } catch (e) {
        return fromData.startsWith('/') ? fromData : `/${fromData}`;
      }
    }

    if (link.hasAttribute('data-preserve-return-to')) {
      try {
        const existing = new URL(link.href, window.location.origin).searchParams.get('return_to');
        if (existing) {
          return new URL(existing, window.location.origin).pathname;
        }
      } catch (e) {
        // fall through to current path
      }
    }

    return window.location.pathname;
  }

  /**
   * @param {Document|Element} [container]
   */
  function updateLoginLinks(container) {
    const root = container || document;
    const links = root.querySelectorAll('a[href*="/customer_authentication/login"]');

    links.forEach(function (/** @type {HTMLAnchorElement} */ link) {
      if (link.href && link.href.includes('/customer_authentication/login')) {
        const loginUrl = buildLoginUrl(getReturnTo(link));
        if (loginUrl) {
          link.href = loginUrl;
        }
      }
    });
  }

  function init() {
    updateLoginLinks();

    const observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType === Node.ELEMENT_NODE) {
            updateLoginLinks(/** @type {Element} */ (node));
          }
        });
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
